export default {"src":"/_next/static/media/catalogMapPlaceholder.b01888e1.svg","height":480,"width":1920,"blurWidth":0,"blurHeight":0};